<div class="admin-shell">

  <!-- Top bar -->
  <header class="admin-topbar">
    <span class="navbar-brand" >RCI Admin</span>
    <button (click)="toggleMenu()" class="navbar-toggler" type="button">
            <span class="navbar-toggler-icon"></span>
          </button>

  </header>

  <!-- Mobile slide menu -->
  <nav class="admin-mobile-menu" [class.open]="menuOpen">

    <a *ngIf="isAdmin$ | async" routerLink="/admin/dashboard">Dashboard</a>
    <a **ngIf="isAdmin$ | async" routerLink="/admin/tenants">Tenants</a>
    <a *ngIf="isAdmin$ | async" routerLink="/admin/rentals">Rentals</a>
    <a routerLink="/admin/applications">Applications</a>
    <a *ngIf="isAdmin$ | async" routerLink="/admin/leases">Leases</a>

    <a *ngIf="isAdmin$ | async" routerLink="/admin/payments">
      Payments
    </a>
    <li class="nav-item">
                <a class="nav-link nav-login" *ngIf="auth.user$ | async as user" (click)="logout()">Log Out</a>
              </li>
  </nav>
   <nav class="navbar navbar-expand-lg fixed-top custom-navbar h-12 desktop-nav">
        <div class="container">
          <a class="navbar-brand" href="#">RCI Admin</a>

          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
            aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
            <ul class="navbar-nav align-items-center">
              <li *ngIf="isAdmin$ | async" class="nav-link nav-login"><a routerLink="/admin/tenants">Tenants</a></li>
              <li *ngIf="isAdmin$ | async" class="nav-link nav-login"><a routerLink="/admin/rentals">Rentals</a></li>
              <li class="nav-link nav-login"><a routerLink="/admin/applications">Applications</a></li>
              <li *ngIf="isAdmin$ | async"  class="nav-link nav-login"><a routerLink="/admin/leases">Leases</a></li>
              <li *ngIf="isAdmin$ | async"  class="nav-link nav-login">
                <a routerLink="/admin/payments">
                  Payments
                </a>
              </li>
              <li class="nav-item">
                <ng-container *ngIf=" isAdmin$ | async; else tenantPortal">
                  <!-- User is logged in -->
                  <a class="btn btn-dark nav-signup" (click)="goToDashboard()">Dashboard</a>
                </ng-container>

                <!-- User is not logged in -->
                <ng-template #tenantPortal>
                  <a class="btn btn-dark nav-signup" (click)="goToLogin()">Admin Portal</a>
                </ng-template>
              </li>
              <li class="nav-item">
                <a class="nav-link nav-login" *ngIf="auth.user$ | async as user" (click)="logout()">Log Out</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

  <!-- Main content -->
  <main class="admin-content">
    <router-outlet></router-outlet>
  </main>

  <!-- Bottom nav (mobile only) -->
  <nav class="admin-bottom-nav d-md-none">
    <a routerLink="/admin/dashboard">🏠</a>
    <a routerLink="/admin/tenants">👤</a>
    <a routerLink="/admin/applications">📄</a>
    <a routerLink="/admin/rentals">🏢</a>
  </nav>

</div>

